import React from "react";
import { Select, Option } from "@ingka/select";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const StyledSelect = styled(Select)`
	width: 90%;
	max-width: ${props => props.maxwidth || "500px"};
	margin-left: 30px;
	margin-bottom: 40px;
`;

const OrderActionsView = ({ onChange, selectedAction, orderActions }) => {
	const { orderDetails } = useSelector(state => state.orderCorrectionController);

	return (
		<StyledSelect
			id="orderActions"
			label={
				<div>
					Action
					<font color="red"> * </font>
				</div>
			}
			onChange={(e, isHintSelected) => {
				onChange({
					value: e.target.options[e.target.selectedIndex].value,
					isDummy: isHintSelected
				});
			}}
			value={selectedAction}
			disabled={orderDetails.length === 0 || (orderDetails.length === 1 && orderDetails[0].isEmptyLine)}
		>
			{orderActions.map(orderAction => (
				<Option key={orderAction.value} value={orderAction.value} name={orderAction.text} />
			))}
		</StyledSelect>
	);
};

OrderActionsView.propTypes = {
	onChange: PropTypes.func.isRequired,
	selectedAction: PropTypes.string,
	orderActions: PropTypes.array.isRequired
};

export default OrderActionsView;
